// 구글 로그인(Google Identity Services) — 버튼이 필요할 때만 스크립트를 한 번 내려받는다
const GSI_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

type GoogleCredentialResponse = { credential: string };

type GoogleAccountsId = {
  initialize: (config: {
    client_id: string;
    callback: (response: GoogleCredentialResponse) => void;
    ux_mode?: 'popup' | 'redirect';
  }) => void;
  renderButton: (
    parent: HTMLElement,
    options: { theme?: string; size?: string; text?: string; shape?: string; width?: number; locale?: string },
  ) => void;
};

declare global {
  interface Window {
    google?: { accounts: { id: GoogleAccountsId } };
  }
}

let loadPromise: Promise<GoogleAccountsId> | null = null;

export const loadGoogleIdentity = (): Promise<GoogleAccountsId> => {
  if (window.google?.accounts?.id) return Promise.resolve(window.google.accounts.id);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = GSI_SCRIPT_SRC;
    script.async = true;
    script.onload = () => (window.google?.accounts?.id ? resolve(window.google.accounts.id) : reject(new Error('GSI')));
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('GSI'));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
};

// 인스타그램·페이스북·카카오톡 등 앱 안 브라우저는 구글이 로그인을 막는다(disallowed_useragent) → 버튼을 숨긴다
const IN_APP_BROWSER_PATTERN =
  /FBAN|FBAV|Instagram|KAKAOTALK|Line\/|NAVER\(inapp|DaumApps|Snapchat|TikTok|BytedanceWebview|; wv\)/i;

export const isInAppBrowser = (userAgent: string) => IN_APP_BROWSER_PATTERN.test(userAgent);

// initialize 는 페이지당 한 번만(여러 번 부르면 구글이 경고) — 버튼이 바뀔 때는 받을 콜백만 갈아 끼운다
let credentialHandler: (idToken: string) => void = () => undefined;
let isInitialized = false;

export const setGoogleCredentialHandler = (googleId: GoogleAccountsId, handler: (idToken: string) => void) => {
  credentialHandler = handler;
  if (isInitialized) return;

  googleId.initialize({
    client_id: GOOGLE_CLIENT_ID,
    callback: ({ credential }) => credentialHandler(credential),
    ux_mode: 'popup',
  });
  isInitialized = true;
};
